export function detectCrmParams(queryParams: { [key: string]: string}) {
    const payloadKeys = ["id", "type"];
    const crmKeys = ['provider', 'iscrmlogin', 'payload'];
    return Object.keys(queryParams).some(key =>
        crmKeys.includes(key) &&
        (key !== 'payload' || Object.keys(JSON.parse(queryParams[key])).some(payloadKey => payloadKeys.includes(payloadKey)))
    );
}
